// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8591966","900":"323607cf"}[chunkId] + ".chunk.js";
};